import {
  LINK_USAGE_STATUS_CONFIRM,
  LINK_USAGE_STATUS_ERROR,
  LINK_USAGE_STATUS_PENDING,
  LINK_USAGE_STATUS_SUCCESS,
  LINK_USAGE_STATUS_REDIRECT,
} from 'apps/settings/actions/accountDetails/paymentUsage';

import { groupValidPaymentTokens } from 'apps/settings/utils/storedPaymentDetails';

export function initLinkUsage({ state, action }) {
  return {
    ...state,
    linkUsagePaymentUrl: `/webshop${action.data.paymentUrl}`,
    linkUsageStatus: LINK_USAGE_STATUS_PENDING,
  };
}

export function initLinkUsageRedirect({ state, action }) {
  return {
    ...state,
    linkUsagePaymentUrl: `/webshop${action.data.paymentUrl}`,
    linkUsageStatus: LINK_USAGE_STATUS_REDIRECT,
    linkUsagePaymentStatus: LINK_USAGE_STATUS_REDIRECT,
  };
}

export function initLinkUsageError({ state, action }) {
  return {
    ...state,
    linkUsagePaymentUrl: '',
    errorMessage: action.error,
    linkUsagePaymentStatus: LINK_USAGE_STATUS_SUCCESS,
    linkUsageStatus: LINK_USAGE_STATUS_ERROR,
  };
}

export function reinitLinkUsagePayment({ state }) {
  return {
    ...state,
    linkUsagePaymentStatus: LINK_USAGE_STATUS_PENDING,
    linkUsageStatus: LINK_USAGE_STATUS_PENDING,
    errorMessage: null,
  };
}

export function setLinkUsageInitialState({ state }) {
  return {
    ...state,
    linkUsageStatus: LINK_USAGE_STATUS_CONFIRM,
    linkUsagePaymentStatus: LINK_USAGE_STATUS_PENDING,
    linkUsagePaymentUrl: '',
    errorMessage: null,
  };
}

export function finishLinkUsagePayment({ state, action }) {
  return {
    ...state,
    linkUsagePaymentStatus: action.paymentStatus,
  };
}

export function setPaymentDetails({ state, action }) {
  return {
    ...state,
    groupedPaymentTokens: groupValidPaymentTokens(action.paymentTokens, action.isPayPalPaymentEnabled),
    possibleUsages: action.possibleUsages,
    hasContactAddress: action.hasContactAddress,
    deliveryPassFailedDataHolder: action.deliveryPassFailedDataHolder,
  };
}

export function setPaymentMethodError({ state, action }) {
  return { ...state, paymentMethodError: action.errorCode };
}
